import React,{useState,useEffect} from "react"
import { Card, CardBody, Col, Row, Spinner, Table } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { getSalesChartData } from "helpers/backend_helper"

const TopCustomer = props => {

  const [seletedMonth, setSeletedMonth] = useState("15d")
  const [loading, setLoading] = useState(false)
  const [sellingData, setSellingData] = useState([])

  useEffect(() => {
    getSalesData(seletedMonth,'customersales')
    return () => {
      setSellingData([])
    }
  }, []);

  const onChangeMonth = value => {
    setSeletedMonth(value)
    getSalesData(value,'customersales')
  }

  const getSalesData = async(input,type) => {
    setLoading(true)
    getSalesChartData({
      key : input,
      id: type
    }).then(response => {
      setSellingData(response)
      setLoading(false)
    })
  }

  return (
    <React.Fragment>
      <Col xl={6}>

        <Card>
          <CardBody>
            <div className="clearfix">
              
              
              <div className="float-end">
                <div className="input-group input-group">
                  <select
                    className="form-select form-select-sm"
                    value={seletedMonth}
                    onChange={(e) => {
                      onChangeMonth(e.target.value)
                    }}
                  >
                    <option value="7d">Last 7 Days</option>
                    <option value="15d">Last 15 Days</option>
                    <option value="30d">Last 1 Month</option>
                    <option value="90d">Last 3 Months</option>
                    <option value="180d">Last 6 Months</option>
                    <option value="365d">Last 1 Year</option>
                  </select>
                </div>
              </div>
              {loading && <div className="float-end">
               <Spinner style={{ width: '1.5rem', height: '1.5rem' }} className="mx-1" color="primary" />
              </div> 
              }
              <h4 className="card-title mb-4">Top Customers by Sales Amount</h4>
            </div>

            <div className="table-responsive mt-4">
              <Table className="table align-middle mb-0">
                <tbody>
                  {(sellingData || []).map((data, key) => {
                    return (
                      <tr key={key}>
                        <td>
                          <h5 className="font-size-14 ">{key + 1}</h5>
                        </td>
                        <td>
                          <h5 className="font-size-14 ">{data.name}</h5>
                        </td>
                        <td>
                          <h5 className="font-size-14">
                            <i className="bx bx-rupee font-size-15"></i>
                            {Number(data.total).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                            <span className="text-muted font-size-12 ms-2">({data.count} txns)</span>
                          </h5>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>

          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default TopCustomer
